import { GpsFixed } from "@mui/icons-material";
import { Box } from "@mui/system";
import L from "leaflet";
import React from "react";
import ReactDOMServer from "react-dom/server";
import { Marker } from "react-leaflet";
import { useMap } from "Utils/hooks";

const LeafletGeolocationMarker = () => {
  const { geolocation } = useMap();


  return geolocation ? (
    <Marker
      icon={L.divIcon({
        className: "custom icon",
        html: ReactDOMServer.renderToString(<GeoMarker />),
      })}
      position={[geolocation.lat, geolocation.lng]}
    />
  ) : null;
};

export default LeafletGeolocationMarker;

const GeoMarker = () => {
  return (
    <Box
      style={{
        backgroundColor: "rgba(255,255,255,.6)",
        backdropFilter: "blur(3px)",
        borderColor: "transparent",
        borderWidth: "0px",
        borderStyle: "solid",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        width: 40,
        height: 40,
        borderRadius: "50%",
        boxShadow: 3,
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <GpsFixed htmlColor="red" />
    </Box>
  );
};
